// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mega-menu-block-item .megamenu-sublink[data-v-09eac306]{border-radius:.25rem;display:inline-block;font-weight:400;padding:.5rem .75rem;transition-duration:.3s;transition-property:all;transition-timing-function:cubic-bezier(.4,0,.2,1)}.mega-menu-block-item .megamenu-sublink[data-v-09eac306]:hover{background-color:rgba(31,21,9,.05);background-color:rgba(31,21,9,var(--tw-bg-opacity));--tw-bg-opacity:0.05}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
